import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  TResponse_ReportMetricColumnConfig,
  TRequest_SaveReportConfiguration,
  TRequest_ValidateReportMetricConfig,
  TRequest_ReportMetricColumnConfig,
  TResponse_SaveReportConfigurationSuccess,
  TResponse_ValidateReportMetricConfig,
} from '@monorepo/types';
import { REnvProvider } from './report.env.provider';

@Injectable({
  providedIn: 'root',
})
export class ReportsAdvanceSettingsDataProvider {
  constructor(public http: HttpClient, private envProvider: REnvProvider) {}

  getMetricColumns(reportParams: TRequest_ReportMetricColumnConfig) {
    const url = this.envProvider
      .getReportGatewayEnvVar('REPORT_METRIC_COLUMN_CONFIG')
      .replace(':REPORT_TYPE', reportParams.reportType)
      .replace(':DURATION_RANGE', reportParams.durationRangeType);

    const queryParams = [
      {
        k: 'fetchDefaultData',
        v: reportParams.fetchDefaultData || false,
      },
      {
        k: 'applicationId',
        v: reportParams.applicationId || false,
      },
      {
        k: 'processId',
        v: reportParams.processId || false,
      },
    ].filter((params) => params.v);

    const params = queryParams.reduce((prev, curr) => prev.append(curr.k, curr.v), new HttpParams());

    return this.http.get<TResponse_ReportMetricColumnConfig>(url, { params });
  }

  saveReportConfiguration(requestParams: TRequest_SaveReportConfiguration) {
    const url = this.envProvider.getReportGatewayEnvVar('SAVE_REPORT_CONFIGURATION');
    return this.http.post<TResponse_SaveReportConfigurationSuccess>(url, requestParams);
  }

  validateReportMetric(requestParams: TRequest_ValidateReportMetricConfig) {
    const url = this.envProvider.getReportGatewayEnvVar('VALIDATE_REPORT_METRIC_CONFIG');
    return this.http.post<TResponse_ValidateReportMetricConfig>(url, requestParams);
  }
}
